import {Box, css, DSIconChevronDown, DSIconMisc, DSListSelector, DSRawButton, Row} from "@cdx/ds";
import {VisionBoardBag} from "./canvas-utils";
import {useLocalStorageState} from "../../lib/storage";
import {api} from "../../lib/api";
import {VisionBoard} from "../../cdx-models/VisionBoard";
import {ArrowOverlay, DropDownForChild} from "@cdx/common";
import {colorThemes} from "@cdx/ds/css/themes/color-overwrites.css";
import {useHistory} from "react-router";
import {waitForResult} from "../../lib/wait-for-result";

type OverlayProps = {
  overlayProps: any;
  current: VisionBoard;
};
const Overlay = ({current, overlayProps}: OverlayProps) => {
  const [lastVisitedBoards] = useLocalStorageState("last-visited-vision-boards", []);
  const boards = (lastVisitedBoards || []).map((id) =>
    api.getModel({modelName: "visionBoard", id})
  );
  const history = useHistory();
  const handleChange = (id: string | null) => {
    if (id) {
      waitForResult(
        () => api.getModel({modelName: "visionBoard", id})?.accountSeq,
        (seq) => {
          history.push({search: `visionBoard=${seq}`});
        }
      );
    }
  };
  return (
    <ArrowOverlay
      arrowSize="sm"
      {...overlayProps}
      bg={null}
      className={css({bg: "foreground", pa: "12px", width: "cardPropChangeOverlay"})}
      outerClassName={colorThemes.gray750}
      arrowUsesBgVar
    >
      <DSListSelector
        label="Choose recently Opened Board"
        getOptions={() => boards}
        optionToKey={(b) => (b ? b.id : null)}
        optionToSearchString={(b) => (b === null ? "None" : b.card.title)}
        renderOption={(b) => (b === null ? "No Vision Board" : b.card.title)}
        initalSelectionKey={current.id}
        currentOptionKey={current.id}
        onConfirm={handleChange}
        autoFocus
      />
    </ArrowOverlay>
  );
};

type VisionBoardPickerProps = {
  bag: VisionBoardBag;
};
const VisionBoardPicker = ({bag}: VisionBoardPickerProps) => {
  return (
    <DropDownForChild
      overlayProps={{placement: "bottom", distanceFromAnchor: 10}}
      renderOverlay={(props) => <Overlay overlayProps={props} current={bag.visionBoard} />}
    >
      <DSRawButton
        variant="secondary"
        // active={Boolean(isOpen || badDeck)}
        contentPadding={null}
      >
        <Row sp="4px" align="center">
          <DSIconMisc />
          <Box pl="2px">{bag.visionBoard.card.title}</Box>
          <DSIconChevronDown className={css({ml: "auto"})} />
        </Row>
      </DSRawButton>
    </DropDownForChild>
  );
};

export default VisionBoardPicker;
